import Vue from 'vue';

Vue.component('report-fuel-index', () =>
    import(/* webpackChunkName: 'report-fuel-index' */ './report-fuel-index.vue'),
);

Vue.component('report-movement-index', () =>
    import(/* webpackChunkName: 'report-movement-index' */ './report-movement-index.vue'),
);

Vue.component('fuel-price-report', () =>
    import(/* webpackChunkName: 'fuel-price-report' */ './fuel-price-report.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/fuel/index.js